import type { FC } from 'react';
import React from 'react';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';

import type { TFormRadio } from './models';

export const FormRadio: FC<TFormRadio> = ({
    BaseRadio,
    Field,
    checked,
    children,
    className,
    name,
    value,
    settings = {
        size: 's',
    },
}) => (
    <Field
        defaultValue={checked ? value : undefined}
        name={name}
        render={({ input, meta }) => (
            <div className={className}>
                <BaseRadio
                    forwardedRef={input.checked ? actions.getRef(meta) : undefined}
                    {...input}
                    {...settings}
                >
                    {children}
                </BaseRadio>
            </div>
        )}
        type="radio"
        value={value}
    />
);
